import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";

export default function Footer({ style }) {
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.footerContainer}>
        <div>
          <img
            src="/logo.png"
            alt="logo"
            className={styles.logo}
            onClick={() => {
              navigate("/");
            }}
          />
        </div>
        <h2 className={styles.text}>
          We do not host any of the content served.{" "}
        </h2>
        
      </div>
      <div className={styles.footerCopyrights}>© Created by Jhe</div>
    </>
  );
}
